import type { DiscoveredRouteModule } from '@/router/generator/types';

// Local constants
const HomeView = () => import('@/views/HomeView.vue');
export const NAME_HOME = 'Home';
export const PATH_HOME = 'home';

export const route: DiscoveredRouteModule = {
  id: 'app.home',
  scope: 'app',
  moduleKey: 'home',
  name: NAME_HOME,
  path: PATH_HOME,
  component: HomeView,
  meta: {
    dataLoaders: ['project_settings']
  },
  requiresFeature: 'home'
};


